export enum PlanDurationType {
    Unlimited = 'Unlimited',
    Annually = 'Annually',
    Biannually = 'Biannually'
}